//Dynamically Construct a list of classes by removing falsy values
export const classList = (...classes: (string | boolean)[]) => {
  return classes.filter(item => !!item).join(" ")
}
